import { Link } from 'react-router-dom';
import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import WorkflowHero from '@/pages/how-it-works/components/WorkflowHero';
import AgentPipeline from '@/pages/how-it-works/components/AgentPipeline';
import FutureWorkflows from '@/pages/how-it-works/components/FutureWorkflows';
import LiveVsPlanned from '@/pages/how-it-works/components/LiveVsPlanned';

export default function HowItWorksPage() {
  return (
    <div className="bg-background-50 text-foreground-950 min-h-screen">
      <Header />
      <main>
        <WorkflowHero />

        <div className="bg-secondary-50 border-b border-secondary-200 px-4 md:px-8 py-4 flex items-start gap-3">
          <span className="w-5 h-5 flex items-center justify-center text-secondary-700 shrink-0 mt-0.5"><i className="ri-information-line"></i></span>
          <p className="text-sm text-secondary-900">
            <strong className="font-semibold">Conceptual Preview &mdash; AI Automation Not Yet Operational.</strong> Everything below illustrates planned automation. Nothing here publishes automatically, and no production data is touched by this page.
          </p>
        </div>

        <AgentPipeline />
        <FutureWorkflows />
        <LiveVsPlanned />

        <section className="bg-background-50 px-4 md:px-8 py-14 md:py-20">
          <div className="rounded-lg border border-background-200 bg-background-100 p-6 md:p-8 flex flex-col md:flex-row md:items-center justify-between gap-5">
            <div>
              <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">See it in the demo walkthrough</h2>
              <p className="mt-2 text-foreground-600 text-sm max-w-xl">Follow the guided click-path through every part of GreenSide News, including this concept page and the management preview.</p>
            </div>
            <Link to="/demo" className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 font-label font-bold uppercase tracking-wider text-sm px-5 py-3 rounded-md whitespace-nowrap cursor-pointer transition-colors shrink-0">
              <span className="w-4 h-4 flex items-center justify-center"><i className="ri-route-line"></i></span>
              Open demo guide
            </Link>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}